export default "__VITE_ASSET__CsoE90De__"